const routes = [
  {
    path: "/disputes",
    name: "DisputesHome",
    component: () => import("@/views/disputes/DisputesHome.vue"),
    meta: { feature: "disputes", requiresAuth: true, app: ["marketing", "disputes"] },
  },
];
export default routes;
